/** 响应式断点（doc/dev_plan.md §1.2）：≥1280 三栏；768–1279 两栏 + 抽屉；<768 单栏 + 底部 tab */
export const BREAKPOINTS = { tablet: 768, desktop: 1280 } as const;
export type Layout = "desktop" | "tablet" | "mobile";

export function layoutFor(width: number): Layout {
  if (width >= BREAKPOINTS.desktop) return "desktop";
  if (width >= BREAKPOINTS.tablet) return "tablet";
  return "mobile";
}

/** 触控目标下限（px） */
export const TOUCH_TARGET = 44;
